<div
    class="table__overflow"
    *ngIf="!this.isLoading">
    <table
        class="table-view"
        *ngIf="linkedEmployees.length > 0">
        <tr>
            <th scope="col">Employees</th>
            <th class="td-small"></th>
        </tr>
        <tr *ngFor="let linkedEmployee of work.linkedEmployees">
            <td>
                <app-pill-employee [employee]="linkedEmployee.employee"></app-pill-employee>
            </td>
            <td>
                <a (click)="unlinkItemById(linkedEmployee.uuid)">
                    <p style="color: red; cursor: pointer">
                        <i class="las la-trash"></i>
                    </p>
                </a>
            </td>
        </tr>

        <tr>
            <td
                colspan="2"
                class="table-view__add"
                (click)="openSelectModal()">
                <i class="las la-plus"></i> New employee
            </td>
        </tr>
    </table>
    <app-loading-message *ngIf="removingLink"></app-loading-message>

    <div *ngIf="linkedEmployees.length == 0">
        <app-message-empty
            [title]="emptyMessageTitle"
            [subtitle]="emptyMessageDescription"
            [icon]="'../../assets/img/open-box.png'">
            <a
                *appIsPermitted="{
                    module: 'EMPLOYEES',
                    operator: 'AND',
                    actions: ['CREATE']
                }"
                (click)="openSelectModal()"
                class="button button--primary"
                >Add employee</a
            >
        </app-message-empty>
    </div>
</div>

<div *ngIf="this.isLoading">
    <app-loading-message></app-loading-message>
</div>
